import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {
  RatingWrapper,
  QualityGroup,
  Answer,
  AnswerText,
  Yes,
  Maybe,
  No,
  GreenDot,
  RedDot,
  OrangeDot,
  SubBlock,
  Question,
  SmallText,
  CommentsWrapper,
  Comments
} from './Feedback.style';
import {FEEDBACK, MAX_CHOSEN_QUALITIES} from '../../constants/constant';
import {arrayToObject} from '../../helpers/array.helper';
import {ChosenQuality} from './ChosenQuality';

export class FeedbackRating extends Component {
  constructor(props) {
    super(props);
    const {rating, comment} = props.feedback;
    this.state = {
      rating,
      comment
    };
    this.setAnswer = this.setAnswer.bind(this);
    this.setYes = this.setYes.bind(this);
    this.setMaybe = this.setMaybe.bind(this);
    this.setNo = this.setNo.bind(this);
    this.chooseQuality = this.chooseQuality.bind(this);
    this.updateComment = this.updateComment.bind(this);
    this.updateCommentOnBlur = this.updateCommentOnBlur.bind(this);
  }

  setAnswer(rating){
    const {setMealFeedback, feedback, pos} = this.props;
    const updated = Object.assign({}, feedback, rating);
    setMealFeedback(updated, pos);
  }
  setYes() {
    const rating = {rating: FEEDBACK.WOULD_ORDER_AGAIN};
    this.setAnswer(rating);
  }

  setMaybe() {
    const rating = {rating: FEEDBACK.MAYBE_ORDER_AGAIN};
    this.setAnswer(rating);
  }

  setNo() {
    const rating = {rating: FEEDBACK.WOULD_NOT_ORDER_AGAIN};
    this.setAnswer(rating);
  }

  chooseQuality(quality) {
    const {feedback, setMealFeedback, pos} = this.props;
    const {chosenQualities} = feedback;

    let newChosenQualities = [];
    if (typeof chosenQualities === 'undefined') {
      newChosenQualities = [quality];
    } else {
      let index;
      chosenQualities.some((chosen, i) => {
        if (chosen === quality) {
          index = i;
        }
      });
      if (index === 0) {
        newChosenQualities = chosenQualities.slice(1);
      } else if (index > 0) {
        newChosenQualities = [
          ...chosenQualities.slice(0, index),
          ...chosenQualities.slice(index + 1)
        ];
      } else {
        newChosenQualities = chosenQualities.length < MAX_CHOSEN_QUALITIES
          ? [...chosenQualities, quality]
          : [quality, ...chosenQualities.slice(1)];
      }
    }
    const updated = Object.assign({}, feedback, {chosenQualities: newChosenQualities});
    setMealFeedback(updated, pos);
  }

  updateComment(e) {
    this.setState({comment: e.target.value});
  }

  updateCommentOnBlur() {
    const {feedback, setMealFeedback, pos} = this.props;
    const comment = Object.assign({}, feedback, {comment: this.state.comment});
    setMealFeedback(comment, pos);
  }

  render() {
    const {feedback} = this.props;
    const {rating, chosenQualities} = feedback;
    const renderSelections = rating && feedback.possibleQualities && (
        feedback.possibleQualities.sort().map(quality => (
          <ChosenQuality
            key={quality}
            rating={rating}
            quality={quality}
            chosenQualities={arrayToObject(chosenQualities)}
            chooseQualityCallback={this.chooseQuality}
          />
        ))
      );
    const renderEachComment = rating && (
      <QualityGroup>
        <Question>
          <FormattedMessage id="feedback.comments" />
        </Question>
        <CommentsWrapper>
          <Comments
            placeholder="Share your thoughts about the meal"
            value={this.state.comment}
            onChange={this.updateComment}
            onBlur={this.updateCommentOnBlur}
          />
        </CommentsWrapper>
      </QualityGroup>
    );
    const reasonTitle =
      rating && rating === FEEDBACK.WOULD_ORDER_AGAIN ? 'feedback.likeMost' : 'feedback.unlikeMost';
    const renderQualityGroup =
      rating &&
      rating !== FEEDBACK.MAYBE_ORDER_AGAIN && (
        <QualityGroup>
          <SubBlock>
            <Question>
              <FormattedMessage id={reasonTitle} />
              <SmallText>
                <FormattedMessage id="feedback.upToThree" />
              </SmallText>
            </Question>
          </SubBlock>
          {renderSelections}
        </QualityGroup>
      );
    return (
      <RatingWrapper>
        <Answer>
          <Yes
            selected={rating === FEEDBACK.WOULD_ORDER_AGAIN}
            onClick={this.setYes}
          >
            <GreenDot selected={rating === FEEDBACK.WOULD_ORDER_AGAIN} />
            <AnswerText>Yes</AnswerText>
          </Yes>
          <Maybe
            selected={rating === FEEDBACK.MAYBE_ORDER_AGAIN}
            onClick={this.setMaybe}
          >
            <OrangeDot selected={rating === FEEDBACK.MAYBE_ORDER_AGAIN} />
            <AnswerText>Maybe</AnswerText>
          </Maybe>
          <No
            selected={rating === FEEDBACK.WOULD_NOT_ORDER_AGAIN}
            onClick={this.setNo}
          >
            <RedDot selected={rating === FEEDBACK.WOULD_NOT_ORDER_AGAIN} />
            <AnswerText>No</AnswerText>
          </No>
        </Answer>
        {renderQualityGroup}
        {renderEachComment}
      </RatingWrapper>
    );
  }
}

FeedbackRating.propTypes = {
  feedback: PropTypes.object.isRequired,
  setMealFeedback: PropTypes.func.isRequired,
  pos: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./containers/FeedbackPage/FeedbackRating.js